import { useViewport } from 'contexts/viewport';
import { Button, Drawer, IconButton, Radio, RadioGroup, Stack, Text, styled } from 'shell/components';

const FilterDrawer = ({ filters, setFilters, resetFilters }) => {
    const { device } = useViewport();

    const onClose = () => {
        setFilters((current) => ({ ...current, open: false }));
    };

    return (
        <Drawer anchor={'left'} device={device === 'desktop' ? 'tablet' : device} open={filters.open} onClose={onClose}>
            <Stack spacing={3}>
                <IconButton
                    sx={{ alignSelf: 'flex-end' }}
                    aria-label={'close'}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClose}
                />
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'h6'} weight={'semibold'}>
                        Sort By
                    </Text>
                    <Button variant={'borderless'} onClick={resetFilters}>
                        Reset All
                    </Button>
                </Stack>
                <RadioGroup
                    value={filters.sort}
                    onChange={(_, value) => setFilters((current) => ({ ...current, sort: value }))}
                >
                    <CustomRadio label={'Name A-Z'} labelPlacement={'start'} value={'namea-z'} />
                    <CustomRadio label={'Name Z-A'} labelPlacement={'start'} value={'namez-a'} />
                </RadioGroup>
            </Stack>
        </Drawer>
    );
};

const CustomRadio = styled(Radio)(({ theme }) => ({
    justifyContent: 'space-between',
    '& > .MuiTypography-root': {
        color: theme.palette.ensightful.neutral[700],
    },
}));

export default FilterDrawer;
